module.exports = __webpack_public_path__ + "img/portrait_3.1f7b8eb1.png";